import mitt from "mitt";
import { ConfirmationModal, Snackbar } from "@/application/types";

const instance = mitt<{
  confirm: ConfirmationModal;
  snackbar: Snackbar;
  refreshModule: string;
  "cancel:request": string;
}>();

export default instance;
